import styled, { css, keyframes } from 'styled-components';
import { Text, Button } from '@movember/mo-gel';

//  Animations
export const StyledCookieConsentExpand = keyframes`
    0% {
        max-height: 0px;
    }
    100% {
        max-height: 300px;
    }
`;

export const StyledCookieConsentCollapse = keyframes`
    0% {
        max-height: 300px;
    }
    100% {
        max-height: 0px;
    }
`;

export const StyledCookieConsentTranslateDown = keyframes`
    100% {
        transform: translateY(0)
    }
`;

export const StyledCookieConsentTranslateUp = keyframes`
    100% {
        transform: translateY(-400px)
    }
`;

export const StyledCookieConsent = styled.div`
  background-color: ${(props) => props.theme.colors.actionPrimary300};
  overflow: hidden;

  ${(props) =>
    !props.accepted
      ? css`
          max-height: 0px;
          animation: ${StyledCookieConsentExpand} 0.8s 1s ease-in-out forwards;
        `
      : css`
          animation: ${StyledCookieConsentCollapse} 0.7s 0s ease-in-out forwards;
        `};
`;

export const StyledCookieText = styled(Text)`
  display: inline-block;
  margin: 0;
  color: ${(props) => props.theme.colors.white};
  line-height: 28.08px;
  flex: 4;
`;

export const StyledButton = styled(Button)`
  margin-top: 28px;
  width: unset;
  flex: 1;
  background-image: none;
  background: ${(props) => props.theme.colors.brandThemeDark700};
  color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.brandThemeDark700};
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  white-space: nowrap;
  align-self: center;
  font-size: 0.9rem;

  :hover {
    background-color: ${(props) => props.theme.colors.brandThemeDark500};
    border-color: ${(props) => props.theme.colors.brandThemeDark500};
    color: ${(props) => props.theme.colors.white};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    margin-left: 54px;
    margin-right: 0;
    margin-top: 0;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    margin-left: 54px;
    margin-right: 0;
    margin-top: 0;
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: inherit;
  position: relative;
  background-repeat: repeat-x;
  background-image: linear-gradient(
    to right,
    ${(props) => props.theme.colors.white},
    ${(props) => props.theme.colors.white}
  );
  background-size: 1px 0.112em;
  background-position: 0 1.05em;
  background-position: left 0 bottom 1px;

  :visited {
    color: inherit;
  }
`;

export const StyledWrapper = styled.div`
  margin: 28px;

  ${(props) =>
    !props.accepted
      ? css`
          transform: translateY(-400px);
          animation: ${StyledCookieConsentTranslateDown} 1.1s 0.9s ease-in-out forwards;
        `
      : css`
          transform: translateY(0);
          animation: ${StyledCookieConsentTranslateUp} 1.1s 0s ease-in-out forwards;
        `};

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    ${(props) =>
      !props.accepted
        ? css`
            animation: ${StyledCookieConsentTranslateDown} 1s 0.75s ease-in-out forwards;
          `
        : css`
            animation: ${StyledCookieConsentTranslateUp} 1s 0s ease-in-out forwards;
          `};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}), (max-width: (${(props) =>
  props.theme.breakpoints.lg} + 2*93px)) {
    margin: 50px 93px;

    ${(props) =>
      !props.accepted
        ? css`
            animation: ${StyledCookieConsentTranslateDown} 0.9s 0.7s ease-in-out forwards;
          `
        : css`
            animation: ${StyledCookieConsentTranslateUp} 0.8s 0.1s ease-in-out forwards;
          `};
  }
`;
